import { useEffect, useState } from "react";
import { api } from "../lib/api";

// Shared public marketing data used by the alternate site layouts:
// jobs-today counter, live hiring feed + hired-today, and featured pros.
export function useLandingData() {
    const [jobsToday, setJobsToday] = useState(null);
    const [hiredToday, setHiredToday] = useState(null);
    const [events, setEvents] = useState([]);
    const [pros, setPros] = useState([]);

    useEffect(() => {
        let alive = true;
        api.get("/stats/public").then((r) => { if (alive) setJobsToday(r.data?.jobs_today ?? null); }).catch(() => {});
        api.get("/activity/live").then((r) => {
            if (!alive) return;
            setHiredToday(r.data?.hired_today ?? null);
            setEvents(r.data?.events || []);
        }).catch(() => {});
        api.get("/pros/featured").then((r) => { if (alive) setPros(r.data?.pros || []); }).catch(() => {});
        return () => { alive = false; };
    }, []);

    return { jobsToday, hiredToday, events, pros };
}

// Track the app's light/dark theme (toggled via `html.light`) reactively so
// layout components can adapt map basemaps / illustrations to match.
export function useIsLight() {
    const [light, setLight] = useState(() => typeof document !== "undefined" && document.documentElement.classList.contains("light"));
    useEffect(() => {
        const el = document.documentElement;
        const sync = () => setLight(el.classList.contains("light"));
        sync();
        const obs = new MutationObserver(sync);
        obs.observe(el, { attributes: true, attributeFilter: ["class"] });
        return () => obs.disconnect();
    }, []);
    return light;
}
